import React from 'react'
import './FeedHeader.scss'

const FeedHeader = () => {
    return (
        <div className="feedHeader">
            <h2 className="feedHeader__text">Home</h2>
            <div className="feedHeader__icon">
            </div>
        </div>
    )
}

export default FeedHeader
